import { Link } from 'react-router-dom'
import {Tag, Menu, X, BarChart3, Upload, Store} from 'lucide-react'
import { useState } from 'react'
import AuthButton from './AuthButton'
import { useAuth } from '../hooks/useAuth'

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { user } = useAuth()

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition">
            <Tag className="w-8 h-8 text-green-600" />
            <span className="text-2xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
              GlenCode
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <nav className="flex items-center gap-8">
              <Link to="/" className="text-gray-700 hover:text-green-600 font-medium transition">
                Home
              </Link>
              <Link to="/glen-ivy-guide" className="text-gray-700 hover:text-green-600 font-medium transition">
                Glen Ivy Guide
              </Link>
              <Link to="/all-brands" className="flex items-center gap-1 text-gray-700 hover:text-green-600 font-medium transition">
                <Store className="w-4 h-4" />
                All Brands
              </Link>
              <Link to="/blog" className="text-gray-700 hover:text-green-600 font-medium transition">
                Blog
              </Link>
              <Link to="/submit-deal" className="flex items-center gap-1 text-gray-700 hover:text-green-600 font-medium transition">
                <Upload className="w-4 h-4" />
                Submit Deal
              </Link>
            </nav>
            <AuthButton />
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-4">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className="text-gray-700 hover:text-green-600 font-medium transition py-2"
              >
                Home
              </Link>
              <Link
                to="/glen-ivy-guide"
                onClick={() => setMobileMenuOpen(false)}
                className="text-gray-700 hover:text-green-600 font-medium transition py-2"
              >
                Glen Ivy Guide
              </Link>
              <Link
                to="/all-brands"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-2 text-gray-700 hover:text-green-600 font-medium transition py-2"
              >
                <Store className="w-4 h-4" />
                All Brands
              </Link>
              <Link
                to="/blog"
                onClick={() => setMobileMenuOpen(false)}
                className="text-gray-700 hover:text-green-600 font-medium transition py-2"
              >
                Blog
              </Link>
              <Link
                to="/submit-deal"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-2 text-gray-700 hover:text-green-600 font-medium transition py-2"
              >
                <Upload className="w-4 h-4" />
                Submit Deal
              </Link>
              {user && (
                <>
                  <Link
                    to="/admin/moderation"
                    onClick={() => setMobileMenuOpen(false)}
                    className="text-gray-700 hover:text-blue-600 font-medium transition py-2"
                  >
                    Moderate Deals
                  </Link>
                  <Link
                    to="/admin/analytics"
                    onClick={() => setMobileMenuOpen(false)}
                    className="flex items-center gap-2 text-gray-700 hover:text-blue-600 font-medium transition py-2"
                  >
                    <BarChart3 className="w-4 h-4" />
                    Analytics
                  </Link>
                </>
              )}
            </div>
          </nav>
        )}
      </div>
    </header>
  )
}
